'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _isomorphicFormData = require('isomorphic-form-data');

var _isomorphicFormData2 = _interopRequireDefault(_isomorphicFormData);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function stringify(query) {
  return _qs2.default.stringify(query, { indices: false });
}

function getQuery(query) {
  return (typeof query === 'undefined' ? 'undefined' : _typeof(query)) === 'object' ? '?' + stringify(query) : '';
}

function convertToFormData(body) {
  var form = new _isomorphicFormData2.default();
  Object.keys(body).forEach(function (key) {
    var data = body[key];
    if (!data) return;
    if (Array.isArray(data)) {
      form.append(key, data.join(','));
      return;
    }
    if (data && data.value && data.options) {
      form.append(key, data.value, data.options);
      return;
    }
    form.append(key, data);
  });
  return form;
}

function convertBodyByContentType(opts) {
  if (!opts.body) return {};

  opts.headers = _extends({
    'Content-Type': 'application/x-www-form-urlencoded' }, opts.headers);

  switch (opts.headers['Content-Type']) {
    case 'application/json':
      return { data: JSON.stringify(opts.data) };
    case 'application/x-www-form-urlencoded':
      return { data: stringify(opts.body) };
    case 'multipart/form-data':
      {
        var form = convertToFormData(opts.body);
        return {
          data: form,
          headers: _extends({}, opts.headers, {
            'Content-Type': form.getHeaders()['content-type']
          })
        };
      }
    default:
      throw new Error('Not supported ' + opts.headers['Content-Type'] + ' content type');
  }
}

function callHttp(url, method) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultHeaders = arguments[3];
  var isCrossOrigin = arguments[4];

  opts.headers = _extends({}, opts.headers, defaultHeaders);

  return (0, _axios2.default)(_extends({
    url: url + getQuery(opts.q),
    method: method,
    // true -> include, undefined -> same-origin
    // as same with https://github.com/github/fetch/blob/master/fetch.js#L448-L452
    withCredentials: isCrossOrigin ? true : undefined
  }, opts, {
    headers: _extends({
      'Content-Type': 'application/x-www-form-urlencoded' }, opts.headers),
    responseType: opts.resType || 'text'
  }, convertBodyByContentType(opts))
  // Charles proxy
  // proxy: {
  //   host: 'localhost',
  //   port: 8888,
  // },
  );
}

var HttpClient = function () {
  function HttpClient() {
    var serverURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$defaultReqHeader = _ref.defaultReqHeaders,
        defaultReqHeaders = _ref$defaultReqHeader === undefined ? {} : _ref$defaultReqHeader,
        isCrossOrigin = _ref.isCrossOrigin,
        userId = _ref.userId;

    _classCallCheck(this, HttpClient);

    this.serverURL = serverURL;
    this.defaultReqHeaders = defaultReqHeaders;
    this.isCrossOrigin = !!isCrossOrigin;
    this.userId = userId;
  }

  _createClass(HttpClient, [{
    key: 'req',
    value: function req(method, url, opts) {
      return callHttp(this.serverURL + url, method, opts, this.defaultReqHeaders, this.isCrossOrigin);
    }
  }, {
    key: 'get',
    value: function get(url, opts) {
      return this.req('get', url, opts);
    }
  }, {
    key: 'post',
    value: function post(url, opts) {
      return this.req('post', url, opts);
    }
  }, {
    key: 'put',
    value: function put(url, opts) {
      return this.req('put', url, opts);
    }
  }, {
    key: 'patch',
    value: function patch(url, opts) {
      return this.req('patch', url, opts);
    }
  }, {
    key: 'delete',
    value: function _delete(url, opts) {
      return this.req('delete', url, opts);
    }
    // alias for delete

  }, {
    key: 'del',
    value: function del(url, opts) {
      return this.delete(url, opts);
    }
  }]);

  return HttpClient;
}();

exports.default = HttpClient;


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/utils/http.js
// module id = 522
// module chunks = 1